import { render } from "./EmployeeBulkUpload.vue?vue&type=template&id=b0c47faa&scoped=true"
import script from "./EmployeeBulkUpload.vue?vue&type=script&lang=js"
export * from "./EmployeeBulkUpload.vue?vue&type=script&lang=js"

import "./EmployeeBulkUpload.vue?vue&type=style&index=0&id=b0c47faa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c47faa"]])

export default __exports__